// extracted by mini-css-extract-plugin
export default {"mw_details":"MarkerWall_mw_details__-cxGD"};